import {
  UsuarioSesion
} from '../../model/usuario/usuario-sesion';

/**
 * Puerto Abstracto: UsuarioRepository
 * 
 * Define el contrato para gestión de datos de usuario/sesión.
 * 
 * Arquitectura Hexagonal:
 * - Este puerto está en el dominio
 * - HttpUsuarioRepository (adaptador) lo implementa en infraestructura
 * 
 * @legacy PrestacionServiciosCGRHandler.sessionData()
 * @author Sura - Migración GWT a Spring Boot
 * @since 1.0
 */
export abstract class UsuarioRepository {

  /**
   * Obtiene los datos de sesión del usuario actual.
   * 
   * El DNI se obtiene del SSO (o valor por defecto temporalmente).
   * 
   * @returns Datos de sesión del usuario
   * @throws Error si el usuario no existe o no está activo
   */
  abstract obtenerDatosSesion(): Promise<UsuarioSesion>;

  /**
   * Verifica si el usuario está autenticado y activo.
   * 
   * @returns true si el usuario es válido
   */
  abstract verificarUsuario(): Promise<boolean>;

}
